<template>
    <div class="card mt-3">
        <div class="card-body">
            <div class="row mb-3">
                <div class="col-12">
                    <h6 class="card-title d-inline"><strong>Server #{{ server.serverId }}</strong></h6>
                    <button
                        class="btn btn-sm btn-light float-right d-inline py-0"
                        @click="removeServer">
                        &times; Remove
                    </button>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Server Address</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': serverAddressError }"
                        v-model="server.serverAddress"
                        @change="validateServerAddress" />
                    <div class="invalid-feedback">Please follow IP address or URL format</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Port Number</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': portNumberError }"
                        v-model="server.portNumber"
                        @change="validatePort" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 65535 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Server Username</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="server.username" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Server Password</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="server.password" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Data logging path</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="server.dataLoggingPath" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Error logging path</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="server.errorLoggingPath" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Config file path</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="server.configFilePath" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Server Address</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': ftpserverAddressError }"
                        v-model="server.ftpserverAddress"
                        @change="validateftpServerAddress" />
                    <div class="invalid-feedback">Please follow IP address format</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Port Number</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        :class="{ 'is-invalid': ftpportNumberError }"
                        v-model="server.ftpportNumber"
                        @change="validateftpPort" />
                    <div class="invalid-feedback">Numbers ranging from 1 to 65535 only</div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Username</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="server.ftpusername" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">FTP Password</label>
                </div>
                <div class="col-md-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="server.ftppassword" />
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">Send Data Mode</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="server.senddatamode">
                        <option value="0">Old Data(Saved Data)</option>
                        <option value="1">Latest Data Only</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-4">
                    <label class="col-form-label col-form-label-sm">JSON Data View</label>
                </div>
                <div class="col-md-8">
                    <select
                        class="form-control form-control-sm"
                        v-model="server.jsondataview">
                        <option value="0">JSON TO STRING PLAIN</option>
                        <option value="1">JSON TO STRING SPACED</option>
                        <option value="2">JSON TO STRING PRETTY</option>
                        <option value="4">JSON TO STRING NOZERO</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            serverAddressError: false,
            portNumberError: false,
            ftpserverAddressError: false,
            ftpportNumberError: false
        }
    },
    props: ['server'],
    methods: {
        removeServer() {
            this.$emit('serverRemoved', { serverId: this.serverId })
        },
        validateServerAddress() {
            if(/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.server.serverAddress) || /(\w+\.\w*\.?)+/.test(this.server.serverAddress) || this.server.serverAddress === 'NULL') {
                this.serverAddressError = false
            } else {
                this.serverAddressError = true
            }
        },
        validatePort() {
            if((/^[0-9]+$/.test(this.server.portNumber) && (parseInt(this.server.portNumber) > 0 && parseInt(this.server.portNumber) < 65536)) || this.server.portNumber === 'NULL') {
                this.portNumberError = false
            } else {
                this.portNumberError = true
            }
        },
        validateftpServerAddress() {
            if(/^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/.test(this.server.ftpserverAddress) || /(\w+\.\w*\.?)+/.test(this.server.ftpserverAddress) || this.server.ftpserverAddress === 'NULL') {
                this.ftpserverAddressError = false
            } else {
                this.ftpserverAddressError = true
            }
        },
        validateftpPort() {
            if((/^[0-9]+$/.test(this.server.ftpportNumber) && (parseInt(this.server.ftpportNumber) > 0 && parseInt(this.server.ftpportNumber) < 65536)) || this.server.ftpportNumber === 'NULL') {
                this.ftpportNumberError = false
            } else {
                this.ftpportNumberError = true
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/server-forms/HttpServerForm.vue